"use strict";

exports.__esModule = true;
var _TicketRoutes = require("./TicketRoutes");
Object.keys(_TicketRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketRoutes[key]) return;
  exports[key] = _TicketRoutes[key];
});